export const VALUES_FIELD_NAME = ['contain', 'cover'] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];
